// @flow
import YaKlassRedirect from './YaKlassRedirect';

export default YaKlassRedirect;
